import { Modal, Form, Input, message, Card, Space, Select, Spin } from 'antd';
import { useState, useEffect } from 'react';
import APIUtils from '../../api/APIUtils';
import WebLinks from '../../api/WebLinks';
import constants from '../../constants/constants';
import { GetCustomPriorityLevelIcons, GetPriorityLevelColors, getPriorityCount } from '../../globalFunctions/GlobalFunctions';

const { TextArea } = Input;

const ViewJobDetails = ({ open, jobId, onCancel, buyerId }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dynamicFields, setDynamicFields] = useState([]);
  const [priorityColorCode, setPriorityColorCode] = useState([]);
  const [countryList, setCountryList] = useState([]);

  useEffect(() => {
    if (open && jobId) {
      fetchJobDetails(jobId);
      // if (buyerId) getBuyerPrioritylist(buyerId);
      fetchCountryList();
    } else {
      form.resetFields();
      setDynamicFields([]);
    }
  }, [open, jobId]);

  const fetchJobDetails = async (id) => {
    setLoading(true);
    const response = await APIUtils.apiCall('GET', WebLinks.GetSelectedJobDetails + id);
    if (!response.isCatch && response.resultObj) {
      const values = response.resultObj.data;
      setDynamicFields(values.jobScreeningQuestions || []);
      form.setFieldsValue({
        title: values.title,
        reference: values.reference,
        companyName: values.companyName,
        country: values.countryCode || values.country,
        address: values.address,
        place: values.place,
        county: values.county,
        postcode: values.postcode,
        salary: values.salary,
        salaryPeriod: values.salaryPeriod || '',
        salaryFrom: values.salaryFrom,
        salaryTo: values.salaryTo,
        priority: values.priority?.toString(),
        description: values.description,
        fullTime: values.fullTime === true ? 'Yes' : 'No',
        partTime: values.partTime === true ? 'Yes' : 'No',
        contract: values.contract === true ? 'Yes' : 'No',
        hourlyWork: values.hourlyWork === true ? 'Yes' : 'No',
        jobUrl: values.jobUrl,
        applyEmail: values.applyEmail,
        jobLocation: values.jobLocation || [],
      });
    } else {
      message.error(response?.resultObj?.message || 'Failed to load job details');
    }
    setLoading(false);
  };

  const fetchCountryList = async () => {
    const response = await APIUtils.apiCall('GET', WebLinks.GetCountryList);
    if (!response.isCatch && response.resultObj) {
      setCountryList(response.resultObj.data || []);
    } else {
      setCountryList([]);
    }
  };

  const getBuyerPrioritylist = async (buyerIdParam) => {
    const url = WebLinks.GetBuyerPriorityFilters + buyerIdParam;
    const response = await APIUtils.apiCall('GET', url);
    if (!response.isCatch && response.resultObj) {
      const data = response.resultObj.data || [];
      let temppriorityColorCode = [];
      data.forEach(element => {
        const obj = {
          value: element.priorityLevel.toString(),
          colorValue: data.length > 5 ? GetCustomPriorityLevelIcons(element.priorityLevel) : GetPriorityLevelColors(element.priorityLevel),
          customName: element.customName,
          prioritycount: getPriorityCount(element.priorityLevel, response?.resultObj?.priorityCount)
        };
        temppriorityColorCode.push(obj);
      });
      setPriorityColorCode(temppriorityColorCode);
    } else {
      setPriorityColorCode([]);
    }
  };

  const getSalaryPeriodLabel = (val) => {
    if (!val) return '';
    const found = constants.SalaryDisplayConstants.find((s) => s.value === val);
    return found ? found.label : val;
  };

  const getGreenHighlightClass = (fieldName) =>
    form.getFieldValue(fieldName) === 'Yes'
      ? 'cursor-default border-[#00B2A8] bg-[#00B2A8]/15 text-[#000000]'
      : 'cursor-default';

  return (
    <Modal
      title={'Job Details'}
      open={open}
      onCancel={onCancel}
      footer={null}
      width={800}
      style={{ top: 20 }}
      destroyOnClose
    >
      <Spin spinning={loading}>
        <Form form={form} layout="vertical">
        <div className="grid xs:grid-cols-1 lg:grid-cols-2 gap-4">
          <Form.Item name="title" label="Job Title" className="mb-0">
            <Input readOnly className="cursor-default" />
          </Form.Item>
          <Form.Item name="reference" label="Reference" className="mb-0">
            <Input readOnly className="cursor-default" />
          </Form.Item>
          <Form.Item name="companyName" label="Company Name" className="mb-0">
            <Input readOnly className="cursor-default" />
          </Form.Item>
          <Form.Item name="country" label="Country" className="mb-0">
            <Input readOnly className="cursor-default" value={(countryList.find(c=>c.countryCode===form.getFieldValue('country'))||{}).country || form.getFieldValue('country')} />
          </Form.Item>
          <Form.Item name="address" label="Address" className="mb-0">
            <TextArea rows={1} readOnly className="cursor-default" />
          </Form.Item>
          <Form.Item name="place" label="City/Town" className="mb-0">
            <Input readOnly className="cursor-default" />
          </Form.Item>
          <Form.Item name="county" label="County/State" className="mb-0">
            <Input readOnly className="cursor-default" />
          </Form.Item>
          <Form.Item name="postcode" label="Post code" className="mb-0">
            <Input readOnly className="cursor-default" />
          </Form.Item>
          <Form.Item name="salary" label="Salary Display" className="mb-0">
            <Input readOnly className="cursor-default" />
          </Form.Item>
          <Form.Item name="salaryFrom" label="Salary From" className="mb-0">
            <Input readOnly className="cursor-default" />
          </Form.Item>
          <Form.Item name="salaryTo" label="Salary To" className="mb-0">
            <Input readOnly className="cursor-default" />
          </Form.Item>
          <Form.Item label="Salary Period" className="mb-0">
            <Input value={getSalaryPeriodLabel(form.getFieldValue('salaryPeriod'))} readOnly className="cursor-default" />
          </Form.Item>
          {/* <Form.Item name="priority" label="Priority" className="mb-0">
            <Select
              className="w-full cursor-default"
              open={false}
              showArrow={false}
              options={priorityColorCode?.map(item => ({
                value: item.value,
                label: (
                  <Space>
                    <div className={item.colorValue}></div>
                    {item.customName}
                  </Space>
                ),
              }))}
            />
          </Form.Item> */}
          {/* <Form.Item name="applyEmail" label="Application Email" className="mb-0">
            <Input readOnly className="cursor-default" />
          </Form.Item> */}
        </div>

        <br />
        <div className="grid xs:grid-cols-1 lg:grid-cols-4 gap-4">
          <Form.Item name="fullTime" label="Full Time" className="mb-0">
            <Input readOnly className={getGreenHighlightClass('fullTime')} />
          </Form.Item>
          <Form.Item name="partTime" label="Part Time" className="mb-0">
            <Input readOnly className={getGreenHighlightClass('partTime')} />
          </Form.Item>
          <Form.Item name="contract" label="Contract" className="mb-0">
            <Input readOnly className={getGreenHighlightClass('contract')} />
          </Form.Item>
          <Form.Item name="hourlyWork" label="Hourly Work" className="mb-0">
            <Input readOnly className={getGreenHighlightClass('hourlyWork')} />
          </Form.Item>
        </div>

        <Form.Item name="description" label="Job Description" className="mt-6">
          <div
            className="p-3 min-h-[150px] max-h-[400px] overflow-y-auto"
            dangerouslySetInnerHTML={{
              __html: form.getFieldValue('description') || '',
            }}
          />
        </Form.Item>

        {form.getFieldValue('jobLocation') && form.getFieldValue('jobLocation').length > 0 ? (
          <Card title="Additional Locations" className="mt-6 bg-gray-100">
            {form.getFieldValue('jobLocation').map((loc, idx) => (
              <div key={idx} className="mb-2">
                <div><strong>City/Town:</strong> {loc.place || ''}</div>
                <div><strong>State:</strong> {loc.state || ''}</div>
                <div><strong>Postcode:</strong> {loc.postcode || ''}</div>
              </div>
            ))}
          </Card>
         ) : null}

        {dynamicFields && dynamicFields.length > 0 ? (
          <Card title="Screening Questions" className="bg-gray-100 mt-6">
            {dynamicFields.map((field, idx) => (
              <Form.Item key={idx} label={field.questionText} className="mb-0">
                <Input value={field.responseType === 'textarea' ? field.answer || '' : field.answer || ''} readOnly className="cursor-default" />
              </Form.Item>
            ))}
          </Card>
        ) : null}

      </Form>
    </Spin>
    </Modal>
  );
};

export default ViewJobDetails;
